import {constants} from "@/constants";

export const OPENAI_ENDPOINT = 'https://api.openai.com'; //'https://openrouter.ai/api'; // 'https://api.openai.com';
export const TTS_ENDPOINT = `https://api.openai.com/v1/audio/speech`;
export const CHAT_COMPLETIONS_ENDPOINT = `${constants.url.API_PREFIX}chat`;
export const MODELS_ENDPOINT = `${OPENAI_ENDPOINT}/v1/models`;
